import {
  Col,
  PageHeader,
  Row,
  Form,
  Input,
  Button,
  message,
  Select,
  DatePicker,
} from "antd";
import { UserAddOutlined, LeftCircleOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { useApiContext } from "../../hooks/useApiContext";
import { dateFormat } from "../../utils/Constants";
import apis from "../../services/apis";

export default function AddEmployee() {
  const {
    employeedispatch,
    employee,
    projectdispatch,
    projects,
    clientdispatch,
    clients,
  } = useApiContext();
  const [employeeform] = Form.useForm();
  const navigate = useNavigate();
  const [projectData, setProjectData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [birthDate, setbirthDate] = useState();
  const [entryDate, setentryDate] = useState();

  useEffect(() => {
    if (projects.length < 1) apis.Projects.list(projectdispatch);
    if (clients.length < 1) apis.Clients.list(clientdispatch);
  }, [projects.length < 1, clients.length < 1]);

  const handleCompanyChange = (value) => {
    const getProject = projects.filter((x) => x.companyId == value);
    setProjectData(getProject);
  };
  const onFinish = (values) => {
    setLoading(true);
    let newValue = {
      ...values,
      id: uuid(),
      empId: `EMPBG${values.borderNumber.slice(-5)}`,
      dob: birthDate,
      entryDate: entryDate
    };
    apis.Employees.create(employeedispatch, newValue).then((res) => {
      employeeform.resetFields();
      setLoading(false);
      // message.success("Employee added successfully!")
    });
    console.log(newValue);
  };
  const onFinishFailed = (error) => {
    message.error(error);
  };
  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => navigate(-1)}
        title="Add Employee"
        subTitle="Enter details to add employee"
      />

      <Form
        initialValues={{ remember: true }}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        form={employeeform}
      >
        <Row className="p-20">
          <Col span={12}>
            <Form.Item
              label="Full Name"
              name="fullName"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please enter fullname",
                  min: 4,
                  message: "Enter minimum 4 characters",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Employee ID / Border Number"
              name="borderNumber"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please enter Border Number",
                  min: 10,
                  message: "Enter minimum 10 characters",
                },
              ]}
            >
              <Input type="number" />
            </Form.Item>
            <Form.Item
              label="Mobile Number"
              name="mobileNumber"
              hasFeedback
              rules={[{ min: 10, message: "Enter minimum 10 digits" }]}
            >
              <Input type="number" />
            </Form.Item>
            <Form.Item label="Gender" name="gender" hasFeedback>
              <Select defaultValue="Select Gender">
                <Select.Option key="Male">Male</Select.Option>
                <Select.Option key="Female">Female</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item label="Nationality" name="nationality" hasFeedback>
              <Select defaultValue="Select Nationality">
                <Select.Option key="Male">Saudia</Select.Option>
                <Select.Option key="Female">Pakistan</Select.Option>
                <Select.Option key="Male">Bangladesh</Select.Option>
                <Select.Option key="Female">India</Select.Option>
              </Select>
            </Form.Item>
     
              
            <Form.Item label="Date of birth" name="dob" hasFeedback>
              <DatePicker
                placeholder="DD/MM/YYYY"
                format={dateFormat}
                onChange={(datestring) =>
                  setbirthDate(datestring.format(dateFormat))
                }
                style={{ width: "100%" }}
              />
              {/* <Input type="date" /> */}
            </Form.Item>
            <Form.Item
              label="MOL ID"
              name="molId"
              hasFeedback
              rules={[{ min: 4, message: "Enter minimum 4 characters" }]}
            >
              <Input type="number" />
            </Form.Item>
            <Form.Item
              label="Passport Number"
              name="passportNumber"
              hasFeedback
            >
              <Input />
            </Form.Item>
            <Form.Item label="Experience" name="experience" hasFeedback>
              <Input />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button
                loading={loading}
                type="primary"
                htmlType="submit"
                icon={<UserAddOutlined />}
                style={{ marginRight: "5px" }}
              >
                Add Employee
              </Button>
              <Button icon={<LeftCircleOutlined />}>Back</Button>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Company Name"
              name="companyId"
              hasFeedback
              warningOnly
              rules={[
                { required: true, message: "Please select Company Name" },
              ]}
            >
              <Select
                placeholder="Select Company" showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                }
                onChange={handleCompanyChange}
              >
                {clients.map((item) => (
                  <Select.Option value={item.id}>
                    {item.companyName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Project Name"
              name="projectId"
              hasFeedback
              warningOnly
              rules={[
                { required: true, message: "Please select Project Name" },
              ]}
            >
              <Select placeholder="Select Project" showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                }
                >
                {projectData.map((item) => (
                  <Select.Option value={item.id}>
                    {item.projectName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Category" name="category" hasFeedback>
              <Input />
            </Form.Item>

            <Form.Item label="Entry Date" name="entryDate" hasFeedback>
            <DatePicker
                placeholder="DD/MM/YYYY"
                format={dateFormat}
                onChange={(datestring) =>
                  setentryDate(datestring.format(dateFormat))
                }
                style={{ width: "100%" }}
              />
              {/* <Input type="date" /> */}
            </Form.Item>
            <Form.Item
              label="Account Number"
              name="iqamaNumber "
              hasFeedback
              warningOnly
              rules={[{ min: 10, message: "Enter minimum 10 characters" }]}
            >
              <Input type="number" />
            </Form.Item>
            <Form.Item label="Basic Salary" name="basicSalary" hasFeedback>
              <Input />
            </Form.Item>

            <Form.Item label="Work shift" name="workShift" hasFeedback>
              <Input />
            </Form.Item>
            <Form.Item label="Leave policy" name="leavePolicy" hasFeedback>
              <Input />
            </Form.Item>
            <Form.Item label="Reference/RL" name="reference" hasFeedback>
              <Input />
            </Form.Item>
            <Form.Item label="Remarks" name="remarks" hasFeedback>
              <Input.TextArea rows={2} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}
